<div class="login-container">
  <div class="login-card">
    <div class="login-header">
      <img src="assets/img/img1.jpeg" alt="Company Logo" class="logo">
      <h2>Welcome Back</h2>
      <p>Please enter your credentials to login</p>
    </div>

    <form class="login-form">
      <div class="form-group">
        <label for="username">Username</label>
        <div class="input-wrapper">
          <span class="input-icon">
            <mat-icon>person_outline</mat-icon>
          </span>
          <input type="text" id="username" placeholder="Enter your username" 
                 name="username" [(ngModel)]="data.username" (ngModelChange)="valuechange1($event)">
        </div>
        <span class="error-message">{{msg1}}</span>
      </div>

      <div class="form-group">
        <label for="password">Password</label>
        <div class="input-wrapper">
          <span class="input-icon">
            <mat-icon>lock_outline</mat-icon>
          </span>
          <input [type]="showPassword ? 'text' : 'password'" id="password" placeholder="Enter your password"
                 name="password" [(ngModel)]="data.password" (ngModelChange)="valuechange2($event)">
          <span class="password-toggle" (click)="togglePasswordVisibility()">
            <mat-icon>{{showPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
          </span>
        </div>
        <span class="error-message">{{msg2}}</span>
        <span class="error-message">{{msg3}}</span>
      </div>

      <button type="submit" class="login-button" (click)="btnClick()">Sign In</button>
    </form>

    <div class="login-footer">
      <a href="#" class="forgot-password" style="color: white;" >Forgot password?</a>
      <!-- <p>Don't have an account? <a href="#" class="sign-up">Sign up</a></p> -->
    </div>
  </div>

  <!-- <div class="login-image">
    <img src="assets/img/img1.jpeg" alt="Login Visual" class="image"/>
  </div> -->
</div>